import React from "react";
import Image from "next/image";
import { getImageURL } from "@/helpers/imageURLHelper";

const TableItem = ({ image, text }) => {
  return (
    <tr>
      <td>
        <div className="tps-inline-image-wrapper tps-float-left tps-float-tablet tps-no-border">
          <div className="tps-inline-image-inner">
            {image && (
              <Image
                alt={image?.alternativeText || ""}
                src={getImageURL(image?.url)}
                quality={90}
                width={image?.width}
                height={image?.height}
                loading="lazy"
                className="tps-inline-image"
              />
            )}
            <div className="tps-inline-image-border" aria-hidden="true" />
          </div>
        </div>
      </td>
      <td dangerouslySetInnerHTML={{ __html: text }}></td>
    </tr>
  );
};

export default TableItem;
